import styles from "./vehicle-grid.module.css";
import VehicleFilter from "../Filter";
import VehicleCard from "./components/VehicleCard";
import { TableLoader } from "../../../../components/LoaderC";
import { TablePagination } from "@mui/material";
import { useState } from "react";
import MobileViewList from "../listview/component/MobileViewList";

const isWithin30Days = (createdAt) => {
    if (!createdAt) return false;
    const createdDate = new Date(createdAt);
    const today = new Date();
    const diffInDays = (today - createdDate) / (1000 * 60 * 60 * 24);
    return diffInDays <= 30;
}

const formatPhone = (phone) => {
    const cleaned = phone.replace(/\D/g, '');

    if (cleaned.length !== 10) return phone;

    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
}

const VehicleGridView = ({ contentLoading, allData, isGridView, handleView, filterData, setFilterData, setAddModalOpen, setDeleteVehicleModalOpen, setSelectedId, setEditData, setEditModalOpen }) => {
    const [perPage, setPerPage] = useState(8);
    const [page, setPage] = useState(0);

    const rowsData = allData.map((item) => {
        const isGuest = Number(item.is_guest) === 1 || item.is_guest === true || item.is_guest === 'true';

        if (isGuest) {
            const fname = item.guest_fname || "";
            const lname = item.guest_lname || "";
            const initials = (fname && lname) ? `${fname[0]}${lname[0]}`.toUpperCase() : "G";
            return {
                id: item.id,
                initials,
                name: `${fname} ${lname}`.trim(),
                phone: formatPhone(item.guest_phone || ""),
                license: item.license,
                make: item.make,
                model: item.model,
                color: item.color,
                property_id: item.property_id,
                property: item.property_name,
                unit: item.apt_no,
                tenant_image: "",
                tenant_id: item.tenant_id,
                tenant_info_id: item.tenant_info_id,
                apt_id: item.apt_id,
                isNew: isWithin30Days(item.created_at),
                image_path: item.image_path,
                image_thumbail_path: item.image_thumbail_path,
                is_guest: 1,
                guest_fname: item.guest_fname || "",
                guest_lname: item.guest_lname || "",
                guest_phone: item.guest_phone || "",
            };
        } else {
            return {
                id: item.id,
                initials: item.tenant_initial,
                name: item.tenant_name,
                license: item.license,
                make: item.make,
                model: item.model,
                color: item.color,
                property_id: item.property_id,
                property: item.property_name,
                unit: item.apt_no,
                tenant_image: item.tenant_image,
                tenant_id: item.tenant_id,
                tenant_info_id: item.tenant_info_id,
                apt_id: item.apt_id,
                isNew: isWithin30Days(item.created_at),
                image_path: item.image_path,
                image_thumbail_path: item.image_thumbail_path,
                is_guest: 0,
            };
        }
    });

    return <div className={`${styles.BodyCon}`}>
        <div className={`${styles.mainCardDiv}`}>
            <div className={`${styles.mainCard}`}>

                <div className="control-pane">
                    {contentLoading && (<div className="Loader TableLoader"><TableLoader /></div>)}

                    {!contentLoading && (<div className={`${styles.Row}`}>

                        <VehicleFilter isGridView={isGridView} handleView={handleView.bind(this)} filterData={filterData} setFilterData={setFilterData.bind(this)} setPage={setPage.bind(this)} setAddModalOpen={setAddModalOpen.bind(this)} />

                        <MobileViewList rowsData={rowsData} setSelectedId={setSelectedId.bind(this)} setDeleteVehicleModalOpen={setDeleteVehicleModalOpen.bind(this)} setEditData={setEditData.bind(this)} setEditModalOpen={setEditModalOpen.bind(this)} />

                        <div className={`${styles.NotesRow}`}>

                            {rowsData?.map((item, index) => {
                                const showBadge = isWithin30Days(item.created_at);
                                return (perPage === -1 || (index >= page * perPage && index < page * perPage + perPage)) ? <VehicleCard item={item} showBadge={showBadge} setDeleteVehicleModalOpen={setDeleteVehicleModalOpen.bind(this)} setSelectedId={setSelectedId.bind(this)} setEditData={setEditData.bind(this)} setEditModalOpen={setEditModalOpen.bind(this)} /> : null;
                            })}

                            {rowsData.length > 0 && (<div className="Pagination TablePaginationNew List">
                                <TablePagination
                                    count={rowsData.length}
                                    color="primary"
                                    page={page}
                                    rowsPerPage={perPage}
                                    onPageChange={(e, v) => setPage(v)}
                                    rowsPerPageOptions={[
                                        { label: '4', value: 4 },
                                        { label: '8', value: 8 },
                                        { label: '16', value: 16 },
                                        { label: 'All', value: -1 },
                                    ]}
                                    onRowsPerPageChange={(e) => {
                                        setPage(0);
                                        setPerPage(e.target.value);
                                    }}
                                    labelRowsPerPage={'Vehicles per Page:'}
                                />
                            </div>)}

                            {rowsData.length === 0 && (<div className={`${styles.NoDataMain}`}>
                                <div className={`${styles.NoDataIMG}`}>
                                    <img src="/static/img/no-car.png" alt="No Data" />
                                </div>
                                <p className={`${styles.NoDataText}`}>Unfortunately!</p>
                                <p className={`${styles.NoDataTextSub}`}>we couldn't find any vehicle at this time.</p>
                            </div>)}

                        </div>
                    </div>)}

                </div>
            </div>
        </div>
    </div>
}

export default VehicleGridView;